import { RefObject, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { setPrintButtonIsClicked } from "../../../../stateManagement/reducers/ContentHeaderSlice";

export function useObjectCardPrint(printRef: RefObject<HTMLElement>, documentTitle?: string) {
    const dispatch = useDispatch()
    const printButtonIsClicked = useAppSelector(state => state.contentHeader.printButtonIsClicked)

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle,
        pageStyle: 'print'
    });

    useEffect(() => {
        if (printButtonIsClicked) {
            handlePrint()
            dispatch(setPrintButtonIsClicked(false))
        }
    }, [printButtonIsClicked])
}


